/* Wholefoods — per-store stock check for pickup-only cart items.
   Loaded on every page from sections/wf-pickup-stock-loader.liquid (header group),
   so it is already running when the slide-out cart is redrawn after an item is added.
   Finds [data-wf-notice] blocks (snippets/wf-pickup-notice.liquid), looks up each item via
   /variants/<id>/?section_id=wf-pickup-stock and lists items not in stock at each store. */
(function () {
  if (window.wfPickupStock) { window.wfPickupStock.scan(); return; }
  var cache = {};
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function getStock(id) {
    if (!cache[id]) {
      cache[id] = fetch('/variants/' + id + '/?section_id=wf-pickup-stock', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var m = html.match(/<script type="application\/json" data-wf-stock>([\s\S]*?)<\/script>/);
          return m ? JSON.parse(m[1]) : null;
        })
        .catch(function () { return null; });
    }
    return cache[id];
  }
  function list(title, names) {
    return '<p class="wf-notice__stock-store">' + title + '</p><ul class="wf-notice__list">' +
      names.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul>';
  }
  function check(notice) {
    notice.setAttribute('data-wf-checked', '1');
    var box = notice.querySelector('[data-wf-stock-box]');
    var dataEl = notice.querySelector('[data-wf-items]');
    if (!box || !dataEl) return;
    var items; try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    Promise.all(items.map(function (it) { return getStock(it.id).then(function (s) { return { t: it.t, s: s }; }); }))
      .then(function (res) {
        var wang = [], wod = [], both = [];
        res.forEach(function (r) {
          if (!r.s) return; // couldn't check: say nothing rather than guess
          if (!r.s.wang && !r.s.wod) both.push(r.t);
          else if (!r.s.wang) wang.push(r.t);
          else if (!r.s.wod) wod.push(r.t);
        });
        var html = '';
        if (wang.length) html += list('Not in stock at <strong>Wangaratta</strong> — remove these if you’re collecting from Wangaratta:', wang);
        if (wod.length) html += list('Not in stock at <strong>Wodonga</strong> — remove these if you’re collecting from Wodonga:', wod);
        if (both.length) html += list('Not in stock at <strong>either store</strong> right now — please remove:', both);
        if (html) {
          box.innerHTML = '<p class="wf-notice__stock-head"><strong>Stock check for pickup</strong></p>' + html;
          box.hidden = false;
        } else {
          box.hidden = true;
        }
      });
  }
  function scan() {
    document.querySelectorAll('[data-wf-notice]:not([data-wf-checked])').forEach(check);
  }
  window.wfPickupStock = { scan: scan };
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();